import { render, staticRenderFns } from "./Err404.vue?vue&type=template&id=811d9024"
import script from "./Err404.vue?vue&type=script&lang=js"
export * from "./Err404.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports